/**
 * Monitoring API service.
 * Provides operations for retrieving sandbox operation statistics.
 *
 * API Endpoints:
 * - GET /monitoring/summary - Summary stats (counts, success rate, latency)
 * - GET /monitoring/timeseries - Time series for success/failure and latency
 * - GET /monitoring/failures - Failure details (top reasons, timeline, table)
 *
 * @module services/monitoringService
 */

import { httpClient } from './httpClient';
import type { MonitoringSummary, MonitoringTimeSeries, MonitoringFailureDetails } from '@/types';

const ENDPOINT = '/monitoring';

export const monitoringService = {
  async getSummary(startTime: string, endTime: string): Promise<MonitoringSummary> {
    console.log('[MonitoringService] Fetching summary:', { startTime, endTime });
    try {
      const response = await httpClient.get<MonitoringSummary>(`${ENDPOINT}/summary`, {
        params: { startTime, endTime },
      });
      console.log('[MonitoringService] Fetched summary');
      return response.data;
    } catch (error) {
      console.error('[MonitoringService] Failed to fetch summary:', error);
      throw error;
    }
  },

  async getTimeSeries(startTime: string, endTime: string): Promise<MonitoringTimeSeries> {
    console.log('[MonitoringService] Fetching time series:', { startTime, endTime });
    try {
      const response = await httpClient.get<MonitoringTimeSeries>(`${ENDPOINT}/timeseries`, {
        params: { startTime, endTime },
      });
      console.log('[MonitoringService] Fetched time series');
      return response.data;
    } catch (error) {
      console.error('[MonitoringService] Failed to fetch time series:', error);
      throw error;
    }
  },

  async getFailureDetails(startTime: string, endTime: string): Promise<MonitoringFailureDetails> {
    console.log('[MonitoringService] Fetching failure details:', { startTime, endTime });
    try {
      const response = await httpClient.get<MonitoringFailureDetails>(`${ENDPOINT}/failures`, {
        params: { startTime, endTime },
      });
      console.log('[MonitoringService] Fetched failure details');
      return response.data;
    } catch (error) {
      console.error('[MonitoringService] Failed to fetch failure details:', error);
      throw error;
    }
  },
};
